import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Nav, { MagazineModalContext } from "./components/Nav";
import Footer from "./components/Footer";
import MagazineModal from "./components/MagazineModal";
import { trackPageview } from "./lib/api";

import Home from "./pages/Home";
import Nocturne from "./pages/Nocturne";
import Films from "./pages/Films";
import Services from "./pages/Services";
import Journal from "./pages/Journal";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Garage from "./pages/Garage";
import NocturneWelcome from "./pages/NocturneWelcome";
import MagazineLanding from "./pages/MagazineLanding";
import Work from "./pages/Work";
import Photography from "./pages/Photography";
import Campaigns from "./pages/Campaigns";
import Impact from "./pages/Impact";
import ImpactCase from "./pages/ImpactCase";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function PageTracker() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    trackPageview(loc.pathname);
    const map = {
      "/": "Good Bandit",
      "/work": "Good Bandit · Work",
      "/work/photography": "Good Bandit · Photography",
      "/work/campaigns": "Good Bandit · Campaigns",
      "/impact": "Good Bandit · Impact",
      "/nocturne": "Good Bandit · Nocturne",
      "/nocturne/welcome": "Good Bandit · Welcome to Nocturne",
      "/magazine": "Good Bandit · Nocturne Magazine",
      "/films": "Good Bandit · Films",
      "/services": "Good Bandit · Services",
      "/journal": "Good Bandit · Journal",
      "/about": "Good Bandit · About",
      "/contact": "Good Bandit · Contact",
      "/garage": "Good Bandit · The Garage",
      "/admin/login": "Good Bandit · Admin",
      "/admin": "Good Bandit · Admin Dashboard",
    };
    document.title = map[loc.pathname] || "Good Bandit";
  }, [loc.pathname]);
  return null;
}

function LayoutShell({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Nav />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

export default function App() {
  const [modal, setModal] = useState({ open: false, source: "home" });
  const ctx = { open: (src) => setModal({ open: true, source: src }) };

  return (
    <div className="App">
      <BrowserRouter>
        <MagazineModalContext.Provider value={ctx}>
          <PageTracker />
          <LayoutShell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/work" element={<Work />} />
              <Route path="/work/photography" element={<Photography />} />
              <Route path="/work/campaigns" element={<Campaigns />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/impact/:slug" element={<ImpactCase />} />
              <Route path="/nocturne" element={<Nocturne />} />
              <Route path="/nocturne/welcome" element={<NocturneWelcome />} />
              <Route path="/magazine" element={<MagazineLanding />} />
              <Route path="/films" element={<Films />} />
              <Route path="/services" element={<Services />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/garage" element={<Garage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </LayoutShell>
          <MagazineModal
            openState={modal.open}
            sourcePage={modal.source}
            onClose={() => setModal({ open: false, source: "home" })}
          />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0a0a0a", color: "#fafafa", border: "1px solid rgba(255,255,255,0.1)" } }} />
        </MagazineModalContext.Provider>
      </BrowserRouter>
    </div>
  );
}
